import React from 'react'

import Checkboxes from '../checkboxes'

export default ({
    services,
    value = [],
    handleChange,
    integratedSolutionsPopUp,
    handleChangeIntegrated,
    integratedValue
}) => {
    const _handleChange = term => {
        const newValues = [...value]

        const indexIfExists = newValues.indexOf(term)

        if(indexIfExists !== -1){
            newValues.splice(indexIfExists, 1)
        }else{
            newValues.push(term)
        }

        handleChange(newValues)
    }

    const {
        icon: {
            sourceUrl: icon
        },
        copy
    } = integratedSolutionsPopUp

    return (
        <>
            <ul className="service-selector">
                { services.map((service, index) => {
                    const {
                        label,
                        icon: {
                            sourceUrl: icon
                        }
                    } = service

                    let textLength = null

                    if(label.length > 20){
                        textLength = 'long'
                    }else if(label.length > 15){
                        textLength = 'medium'
                    }

                    const isActive = value.indexOf(label) !== -1

                    return (
                        <li key={index}>
                            <button 
                                className={isActive ? 'active' : ''}
                                onClick={e => {
                                    e.preventDefault()
                                    _handleChange(label)
                                }}
                            >
                                <img src={icon} />
                                <span className={textLength ? 'length-'+textLength : ''}>
                                    { label }
                                </span>
                            </button>
                        </li>
                    )
                })}
            </ul>
            { value.length > 1 ?
                <div className="integrated-prompt">
                    <img src={icon} />
                    <div className="content">
                        <div className="copy" dangerouslySetInnerHTML={{ __html: copy }} />
                        <Checkboxes
                            handleChange={value => handleChangeIntegrated(value)}
                            options={['Yes', 'No']}
                            single={true}
                            value={integratedValue}
                        />
                    </div>
                </div>
            : null }
        </>
    )
}